export default {
  name: "reply-button",
  components: {},
  props: ["isActive", "isRequesting"],
  data() {
    return {};
  },
  computed: {
    style() {
      if (this.isActive) {
        return `background: ${this.$vuetify.theme.themes.light.primary};`;
      } else {
        return `background: #F3F5F9;`;
      }
    }
  },
  mounted() {},
  methods: {
    replyTicket() {
      this.$emit("reply");
    }
  }
};
